import React from 'react';

import SendIcon from '@mui/icons-material/Send';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { PageJson } from '@/types/domain/childNotebook/entities/pageEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import PageInfo from '@/domain/childNotebook/component/PageInfo';

/**
 * プロパティ
 */
export type Props = {
  /** データ */
  pageApp: PageJson,
  /** 機嫌を表示しない */
  hideCondition: boolean,
  /** 添付ファイル */
  attachments: File[],
  /** 送る */
  send: () => void,
  /**
   * 閉じる
   * @returns なし
   */
  cancel: () => void,
};

const Confirm: React.FC<Props> = ({
  pageApp,
  hideCondition,
  attachments,
  send,
  cancel,
}) => (
  <Dialog
    open
    onClose={() => cancel()}
    TransitionComponent={DialogTransition}
    fullScreen
  >
    <DialogTitle title="連絡帳" />
    <DialogContent>
      <h2>ご家庭入力欄</h2>
      <PageInfo
        data={pageApp}
        attachments={attachments}
        hideCondition={hideCondition}
      />
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={() => send()}
        color="primary"
        startIcon={<SendIcon />}
      >
        送信する
      </Button>
      <Button variant="contained" onClick={() => cancel()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default Confirm;
